import React from 'react'
import { cx } from '@/lib/utils'
import styles from './TwoColumn.module.scss'

type Split = 'equal' | 'narrow-wide'

interface TwoColumnProps {
  children: React.ReactNode
  split?: Split
  gap?: '8' | '10' | '12'
  alignItems?: 'start' | 'center' | 'end'
}

const splitMap: Record<Split, string> = {
  equal: styles.equal,
  'narrow-wide': styles.narrowWide,
}

const gapMap = { '8': styles.gap8, '10': styles.gap10, '12': styles.gap12 } as const

const alignMap = {
  start: styles.alignStart, center: styles.alignCenter, end: styles.alignEnd,
} as const

export const TwoColumn: React.FC<TwoColumnProps> = ({
  children, split = 'equal', gap = '12', alignItems = 'center',
}) => (
  <div className={cx(styles.grid, splitMap[split], gapMap[gap], alignMap[alignItems])}>
    {children}
  </div>
)
